var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('DataGetter',{attrs:{"url":`${_vm.apiRoute}/dashboard`,"params":{
      region: _vm.selectedRegion,
      product: 'Liquid biofuels',
      flow: _vm.indicatorFlows,
    },"childElementType":null,"initialData":_vm.indicatorFlows.reduce((flows, flow) => {
        if (
          flow === '5 year CAGR biofuels consumption' ||
          flow === 'Forecast revision'
        ) {
          flows.push({ flow, value: 0 });
        } else {
          flows.push({ flow, value: 0, year: 2022 });
          flows.push({ flow, value: 0, year: 2028 });
        }
        return flows;
      }, [])},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('IndicatorBox',{key:"transport-indicators",attrs:{"title":`Key transport indicators, ${_vm.selectedRegion}`,"indicators":data
          .toSorted(
            (a, b) =>
              _vm.indicatorFlows.indexOf(a.flow) - _vm.indicatorFlows.indexOf(b.flow)
          )
          .map((row) => ({
            title:
              row.flow === 'Forecast revision'
                ? 'Forecast revision from Renewables 2022'
                : `${row.flow}${
                    row.year && row.year !== 'NOTAPPLICABLE'
                      ? `, ${row.year}`
                      : ''
                  }`,
            text:
              row.flow === 'Forecast revision' && isNaN(parseInt(row.value))
                ? row.value
                : null,
            number: isNaN(parseInt(row.value))
              ? null
              : parseFloat(parseFloat(row.value).toFixed(0)),
            invalid: !row.value,
            units: row.unit,
            description: row.year === 2028 ? 'Forecast' : null,
            arrow: row.flow === 'Forecast revision',
            info:
              row.flow === 'Forecast revision' && isNaN(parseInt(row.value))
                ? '<p>When the forecast has changed from negative to positive, or vice versa, the numerical change cannot be computed.</p>'
                : null,
          })),"notes":_vm.countryNotes[_vm.selectedRegion],"compact":""}})]}}])}),_c('ControlGroup',[_c('ButtonGroup',{attrs:{"options":['Consumption', 'Production', 'Feedstock'].map((value) => ({
          label: value,
          value,
        })),"fixed":""},model:{value:(_vm.selectedFlow),callback:function ($$v) {_vm.selectedFlow=$$v},expression:"selectedFlow"}})],1),_c('DataGetter',{staticClass:"m-block m-block--charts m-block--charts-half",attrs:{"url":_vm.endpoint,"params":{
      region: _vm.selectedRegion,
      publication: _vm.publication,
      product: _vm.useProducts,
    },"initialData":[]},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('FiveYearChart',{attrs:{"selectedRegion":_vm.selectedRegion,"selectedFlow":_vm.selectedFlow,"title":_vm.selectedFlow === 'Feedstock'
          ? `5-year growth`
          : `5-year ${_vm.selectedFlow.toLowerCase()} growth`,"products":_vm.useProducts,"productLabel":_vm.selectedFlow === 'Feedstock' ? 'Feedstock' : 'Fuel',"showAll":"","computeGrowth":"","data":data}}),_c('TimeSeriesChart',{attrs:{"selectedRegion":_vm.selectedRegion,"products":_vm.useProducts,"selectedFlow":_vm.selectedFlow,"allowCaseSelection":"","data":data}})]}}])}),_c('TextContent',{attrs:{"product":"Liquid biofuels","region":_vm.selectedRegion,"apiRoute":_vm.apiRoute,"publication":_vm.publication}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }